export default __webpack_public_path__ + "static/media/DK Validator Transparent Logo.8cffbe02.png";